import React, { useState, useEffect } from "react";

import CloseIcon from "./CloseIcon";
import FilterButtons from "./FilterButtons";
import FilterIcon from "./FilterIcon";
import FilteringIcon from "./FilteringIcon";
function Filters({
  taxTypes,
  filters,
  labels,
  activeFilters,
  resetFilters,
  taxonomy,
  handleFilterChange,
}) {
  const [toggleFilters, setToggleFilters] = useState(false);

  const [hasFilters, setHasFilters] = useState(false);
  useEffect(() => {
    let has = false;
    Object.keys(activeFilters).forEach((filter) => {
      if (activeFilters[filter] && activeFilters[filter].length) {
        has = true;
      }
    });

    setHasFilters(has);
  }, [activeFilters]);

  return (
    <div className="md:v-mb-20 v-mb-5 v-space-y-5 v-font-bold v-font-title">
      <div className="v-flex">
        <div
          className={
            (toggleFilters ? " " : "") +
            " filters  md:v-flex md:v-space-y-0 v-space-y-5 v-items-center v-text-white v-rounded-xl  md:v-px-0 "
          }
        >
          <div className="md:v-hidden">
            <div className="button_su">
              <div className="su_button_circle"></div>

              <div
                className={
                  "hover-effect v-ease-in-out v-duration-300 button_su_inner v-transition tiny develop     form-button v-inline-flex v-items-center v-justify-between  "
                }
                onClick={() => setToggleFilters(!toggleFilters)}
              >
                <div className="v-relative v-z-100">Filters</div>
              </div>
            </div>
          </div>

          <div
            className={
              "md:v-flex v-flex-wrap  " + (toggleFilters ? "" : "v-hidden")
            }
          >
            <div className="button_su su_inverted v-mr-3 v-mb-3">
              <div className="su_button_circle"></div>

              <div
                className={
                  "hover-effect v-ease-in-out v-duration-300 v-cursor-pointer button_su_inner v-transition  hover:v-text-white v-whitespace-nowrap   v-inline-flex v-items-center v-justify-between   v-rounded-full v-px-4 v-py-2 v-text-body v-font-semibold   " +
                  (hasFilters ? "v-text-primary v-bg-white " : "v-bg-primary v-text-white")
                }
                onClick={() => resetFilters()}
              >
                <div className="v-relative v-z-100">{labels["everything"]}</div>
              </div>
            </div>

            {taxTypes.map((key) => (
              <FilterButtons
                key={"filter_" + key}
                filters={filters}
                labels={labels}
                taxonomy={taxonomy ? taxonomy.split(",") : []}
                handleFilterChange={handleFilterChange}
                activeFilters={activeFilters}
                type={key}
              />
            ))}
          </div>
        </div>
      </div>

      {true == false && (
        <div
          className={
            "v-flex v-flex-wrap md:v-flex-row v-flex-col  md:v-space-y-0 v-space-y-5  md:v-space-x-5 "
          }
        >
          {taxTypes.map((key) => {
            return (
              filters[key] &&
              activeFilters[key] &&
              Object.keys(filters[key]).map(function (subKey) {
                return (
                  activeFilters[key].includes(filters[key][subKey]["id"]) && (
                    <div
                      key={"key_" + key + "_" + subKey}
                      className="v-rounded-full v-bg-secondary v-text-white v-px-5 v-py-3 v-cursor-pointer v-inline-flex v-justify-between v-space-x-10 v-items-center"
                      onClick={() =>
                        handleFilterChange(key, filters[key][subKey]["id"])
                      }
                    >
                      <div>{filters[key][subKey]["label"]}</div>

                      <CloseIcon />
                    </div>
                  )
                );
              })
            );
          })}
        </div>
      )}
    </div>
  );
}

export default Filters;
